import React from 'react'
// import valuesOn from 'mout/object/valuesOn'
import values from 'mout/object/values'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText';
import SubtestCard from './SubtestCard';

export default function SubtestCards({
  userAssessment,
  user,
  selectedStudent,
  selectedGroupUA,
  scoringCompare, 
  scoring,
  groupUAs,
  nodes,
  assessmentId,
  groupUA,
  isAssessmentInitializing,
  previousTest,
  year,
  isCompare,
  compareAssismentId,
  currentAssessmentId,
  test1,
  test2,
  isSwap,
  compareGuaYear,
  isLicenseExpired
}) {
  console.log(compareGuaYear)
  // utility function for wrapping the render
  const Aux = props => props.children

  const { role } = user
  let gUA, assessmentSubtests, gUACompare, assessmentSubtestsCompare

  // Subtest card can either be in student mode or educator mode.
  // Student mode is if the role is student or if a student is selected.
  // Educator mode is if a group is selected.
  const studentMode = !!( userAssessment && 
                          userAssessment.assessmentSubtests && 
                          (role === 'Student' || selectedStudent)
                        )
  const educatorMode = !!(role !== 'Student' && selectedGroupUA && groupUAs) 
  
  // Depending on whether we're in studentMode or educatorMode, we have
  // to get our data from slightly different places. We also have to 
  // sort the subtests by their index number so the cards display in 
  // the correct order.
  let sortedSubtests = []
  if (studentMode) {
    sortedSubtests = sortByPropText(values(userAssessment.assessmentSubtests), 'index')
    scoring = scoring
    scoringCompare = scoringCompare
  } else if (educatorMode) {
    if (groupUAs[selectedGroupUA]) {
      gUA = groupUAs[selectedGroupUA][year][currentAssessmentId]
      gUACompare = compareAssismentId && compareGuaYear ? groupUAs[selectedGroupUA][compareGuaYear][compareAssismentId] : null
      assessmentSubtests = gUA && gUA.assessmentSubtests
      assessmentSubtestsCompare = gUACompare && compareAssismentId ? gUACompare.assessmentSubtests : null
      scoring = scoring
      scoringCompare = scoringCompare
      sortedSubtests = sortByPropText(values(assessmentSubtests), 'index')
    }
  }
  return (
    <Aux>
      {sortedSubtests.map(subtest => { 
        const complete =  !!((userAssessment && 
                              userAssessment.destructuredSubtests[subtest.setId].complete === true) ||
                              (educatorMode && !selectedStudent))
        const resume = !!(!complete && userAssessment &&
                          userAssessment.destructuredSubtests[subtest.setId].timeRemaining)
        return (
          <SubtestCard 
            sm='12'
            md='6'
            lg='6'
            xl='3'
            sub={true}
            title={subtest.displayName}
            key={`subTestSummary${subtest.setId}`}
            subtest={subtest}
            resume={resume}
            userAssessmentId={userAssessment && userAssessment.userAssessmentId}
            complete={complete}
            scoring={scoring}
            scoringCompare = {scoringCompare}
            nodes={nodes}
            isStudent={role === 'Student'}
            assessmentId={assessmentId}
            selectedGroupUA={selectedGroupUA}
            selectedStudent={selectedStudent}
            groupUA={groupUA}
            userAssessment={userAssessment}
            user={user}
            groupUAId={selectedGroupUA}
            isAssessmentInitializing={isAssessmentInitializing}
            previousTest={previousTest}
            year={year}
            isCompare = {isCompare}
            test1 = {test1}
            test2 = {test2}
            isSwap = {isSwap}
            isLicenseExpired={isLicenseExpired}
          />
        )
      })}
    </Aux>
  )
}




// WEBPACK FOOTER //
// ./src/components/Assessment/AssessDash/SubtestCards.js